// ─────────────────────────────────────────────────────────────────────────────
// AdminActions.js — the "Recent Admin Actions" feed: what was done, by whom,
// how long ago. Items arrive pre-shaped by mapAdminActions in dashboardService.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./AdminActions.module.css";

function ClockIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#00D492"
      strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="6" r="5" />
      <path d="M6 3V6L8 7" />
    </svg>
  );
}

/** @param {{text: string, who: string, when: string}[]} actions */
export default function AdminActions({ actions }) {
  return (
    <div className={styles.list}>
      {actions.map((a, i) => (
        <div key={i} className={styles.item}>
          <span className={styles.iconWrap}><ClockIcon /></span>
          <div className={styles.text}>
            <div className={styles.msg}>{a.text}</div>
            <div className={styles.meta}>
              <span>{a.who}</span>
              <span className={styles.metaDot}>·</span>
              <span>{a.when}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
